import store from '../../redux/store'
import {
    EDIT_COLLECTIONS_RESET,
    EDIT_COLLECTIONS_GENERALES,
    EDIT_COLLECTIONS_METADATA_MAPPER,
    EDIT_COLLECTIONS_HIGH_FREQUENCY,
    EDIT_COLLECTIONS_IA_CONFIG
} from '../../redux/redux-const'
import APIInvoke from '../../utils/APIInvoke';
import toast from 'react-hot-toast';
import { hasText } from '../../utils/StringUtils';
import { setLoading } from '../../template/app-actions';


const getState = () => {
    return store.getState().pages.editCollection
}

const merge = (type, param) => {
    store.dispatch({
        type,
        payload: {
            ...getState(),
            ...param
        }
    })
}

export const reset = () => {
    store.dispatch({ type: EDIT_COLLECTIONS_RESET })
}

export const init = async (project, collection) => {
    try {
        setLoading(true)
        const response = await (await APIInvoke.invokeGET(`/projects/${project}/collections/${collection}`)).json()
        if (!response.ok) {
            toast.error(response.message)
            return
        }
        let stringSchema = ""
        try {
            stringSchema = JSON.stringify(JSON.parse(response.body.schema?.schema), null, 2)
        } catch (error) {
            stringSchema = response.body.schema?.schema
        }
        merge(EDIT_COLLECTIONS_GENERALES, {
            new: false,
            id: response.body.id,
            name: response.body.name,
            useSchema: hasText(response.body.schema),
            skipUnchangedDocuments: response.body.skipUnchangedDocuments,
            useSchema: response.body.schema?.validate || false,
            rejectInvalid: response.body.schema?.rejectInvalid || false,
            schemaType: response.body.schema?.schemaType || "JSON",
            schema: stringSchema,
            reindexing: response.body.reindexing,
            rules: response.body.rules?.map(rule => ({
                id: rule.id,
                enable: rule.enable,
                name: rule.name,
                description: rule.description,
                expression: rule.expression,
                example: rule.example || "",
                previewExample: rule.previewExample || "",
                webhookId: rule.webhookId,
                notifyTo: rule.notifyTo || []
            })) || [],
            metadataMapper: {
                enabled: response.body.metadataMapper?.enabled,
                mapperMode: response.body.metadataMapper?.mapperMode,
                documentExample: response.body.metadataMapper?.documentExample,
                expression: response.body.metadataMapper?.expression
            },
            indexes: response.body.indexes?.map(index => ({
                id: index.id,
                name: index.name,
                type: index.type,
                expression: index.expression,
                documentExample: index.documentExample
            })) || [],
            highFrequency: {
                inheritsFromProject: response.body.highFrequency?.inheritsFromProject === true,
                enabled: response.body.highFrequency?.enabled === true,
                maxUpdates: response.body.highFrequency?.maxUpdates || 3,
                timeWindow: response.body.highFrequency?.timeWindow || 1,
                timeWindowUnit: response.body.highFrequency?.timeWindowUnit || "SECONDS",
                cooldown: response.body.highFrequency?.cooldown || 30,
                cooldownUnit: response.body.highFrequency?.cooldownUnit || "MINUTES",
            },
            iaConfig: {
                description: response.body.iaConfig?.description || "",
                importantStatements: response.body.iaConfig?.importantStatements || "",
                ignoreStatements: response.body.iaConfig?.ignoreStatements || ""
            }
        })
    } catch (error) {
        toast.error(error.message)
    } finally {
        setLoading(false)
    }
}

export const updateGenerales = (action) => {
    const name = action.target.name
    const type = action.target.type
    let value = action.target.value


    if (type === "checkbox") {
        value = action.target.checked
    }

    merge(EDIT_COLLECTIONS_GENERALES, { [name]: value })
}


export const updateGeneralesEvent = (payload) => {
    merge(EDIT_COLLECTIONS_GENERALES, { ...payload })
}

export const save = async (project, navigate) => {
    const state = getState()
    const request = {
        name: state.name,
        skipUnchangedDocuments: state.skipUnchangedDocuments,
        schema: {
            validate: state.useSchema,
            rejectInvalid: state.rejectInvalid,
            schemaType: state.schemaType,
            schema: state.schema?.replace(/\n/g, "")
        },
        metadataMapper: {
            enabled: state.metadataMapper.enabled,
            mapperMode: state.metadataMapper.mapperMode,
            documentExample: state.metadataMapper.documentExample,
            expression: state.metadataMapper.expression
        },
        highFrequency: {
            inheritsFromProject: state.highFrequency?.inheritsFromProject === true,
            enabled: state.highFrequency?.enabled === true,
            maxUpdates: state.highFrequency.maxUpdates || "",
            timeWindow: state.highFrequency.timeWindow || "",
            timeWindowUnit: state.highFrequency.timeWindowUnit || "",
            cooldown: state.highFrequency.cooldown || "",
            cooldownUnit: state.highFrequency.cooldownUnit || "",
        },
        iaConfig: {
            description: state.iaConfig.description,
            importantStatements: state.iaConfig.importantStatements,
            ignoreStatements: state.iaConfig.ignoreStatements
        }
    }
    const response = state.id
        ? await (await APIInvoke.invokePUT(`/projects/${project}/collections/${state.name}`, request)).json()
        : await (await APIInvoke.invokePOST(`/projects/${project}/collections`, request)).json()
    if (response.ok) {
        merge(EDIT_COLLECTIONS_GENERALES, {
            new: false,
            id: response.body.id,
            name: response.body.name,
            skipUnchangedDocuments: response.body.skipUnchangedDocuments
        })
        toast.success(response.message)
        navigate(`/projects/${project}/collections/${state.name}/edit`)
    } else {
        toast.error(response.message)
    }
}

export const updateMetadataMapper = (action) => {
    const name = action.target.name
    const type = action.target.type
    let value = action.target.value


    if (type === "checkbox") {
        value = action.target.checked
    }

    const state = getState();

    store.dispatch({
        type: EDIT_COLLECTIONS_METADATA_MAPPER,
        payload: {
            ...state.metadataMapper,
            [name]: value
        }
    })
}

function parseJson(str) {
    try {
        return JSON.parse(str);
    } catch (e) {
        return null;
    }
}

export const testMetadataMapping = async (project, collection) => {
    const state = getState();

    const request = {
        expression: state.metadataMapper.expression,
        documentExample: parseJson(state.metadataMapper.documentExample),
    }

    const response = await (await APIInvoke.invokePOST(`/projects/${project}/collections/${collection}/metadata/expression/test`, request)).json()

    store.dispatch({
        type: EDIT_COLLECTIONS_METADATA_MAPPER,
        payload: {
            ...state.metadataMapper,
            result: response.body
        }
    })
}

export const fetchWebhooks = async (project) => {
    try {
        const rawResponse = await APIInvoke.invokeGET(`/projects/${project}/webhooks`);
        const response = await rawResponse.json();

        merge(EDIT_COLLECTIONS_GENERALES, {
            webhooks: response.body
        })
    } catch (e) {
        console.error(e)
    }
}

export const changeIndexLayout = (layout) => {
    const state = getState();
    store.dispatch({
        type: EDIT_COLLECTIONS_GENERALES,
        payload: {
            indexes: {
                ...state.indexes,
                layout: layout
            }
        }
    })
}

export const deleteIndex = (index) => {
    const state = getState();
    store.dispatch({
        type: EDIT_COLLECTIONS_GENERALES,
        payload: { indexes: state.indexes.filter(x => x.id !== index) }
    })
}


export const deleteRule = (index) => {
    const state = getState();
    store.dispatch({
        type: EDIT_COLLECTIONS_GENERALES,
        payload: { rules: state.rules.filter(x => x.id !== index) }
    })
}


export const updateHighFrequency = (action) => {
    const name = action.target.name
    const type = action.target.type
    let value = action.target.value


    if (type === "checkbox") {
        value = action.target.checked
    }

    const state = getState();

    store.dispatch({
        type: EDIT_COLLECTIONS_HIGH_FREQUENCY,
        payload: {
            ...state.highFrequency,
            [name]: value
        }
    })
}


export const updateIAConfig = (action) => {
    const name = action.target.name
    const type = action.target.type
    let value = action.target.value


    if (type === "checkbox") {
        value = action.target.checked
    }

    const state = getState();

    store.dispatch({
        type: EDIT_COLLECTIONS_IA_CONFIG,
        payload: {
            ...state.iaConfig,
            [name]: value
        }
    })
}
